import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'

import Checkbox from '../../../pages/Settings/Controls/Checkbox'

import { uniqueArray } from '../../../utilities'
import useAccess, { PERMS } from '../../../hooks/useAccess'
import { selectAccess, togglePermission } from '../../../slices/accessSlice'
import useStyles from './styles'

const PermissionsDebug: React.FC = () => {
  const dispatch = useAppDispatch()
  const { permissions } = useAppSelector(selectAccess)

  const hasPermission = useAccess()

  const classes = useStyles()

  return (
    <div className={classes.panel}>
      {uniqueArray(Object.values(PERMS), permissions).map(key => (
        <div key={key} className={classes.option}>
          <Checkbox
            checked={hasPermission(key)}
            onCheck={val => dispatch(togglePermission([val, key]))}
          >
            {key}
          </Checkbox>
        </div>
      ))}
    </div>
  )
}

export default PermissionsDebug
